import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {select, Store} from '@ngrx/store';
import {PageState} from './mitteilungen.reducer';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import * as apiKommunikation from '../../../../clients/kommunikation';
import {KommunikationEntityTypes} from '../../../../client-constants';
import MITTEILUNG_ENTITY = KommunikationEntityTypes.MITTEILUNG_ENTITY;
import {GetMitteilungenGruppiertAction} from '../../../../client-ngrx/kommunikation';
import {getAktuelleVeranstaltung} from '../../app-state/app-state.reducer';
import {GetMitteilungenGesendetGruppiertAction} from '../../../../client-ngrx/veranstaltungen';

@Injectable()
export class MitteilungenPageWsEffects {

    @Effect()
    wsMitteilung$ = this.actions$.pipe(
        ofType(WS_READ_MODEL_UPDATED),
        map((x: WsReadModelUpdatedAction) => x),
        filter(x => x.message.entity_type.toUpperCase() === MITTEILUNG_ENTITY.toUpperCase()),
        map((x) => <apiKommunikation.Mitteilung> JSON.parse(x.message.entity)),
        withLatestFrom(this.store.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, veranstaltung]) => veranstaltung !== null && x.korrelation_id === veranstaltung.veranstaltung_id),
        flatMap(([x, veranstaltung]) => {
                return [new GetMitteilungenGruppiertAction(veranstaltung.veranstaltung_id),
                new GetMitteilungenGesendetGruppiertAction(veranstaltung.veranstaltung_id)];
            }
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store<PageState>,
    ) {
    }
}
